import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'
import Heading from '../Heading/Heading'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import Button from '../Button/Button'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import {BrowserName, MobileSystemName} from "../../utils/UserAgentInformations";

export const StyledCard = styled.div`
  flex-direction: column;
  display: flex;
  margin: ${pxToRem(10)} ${pxToRem(10)};
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(384)};
  padding: ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.unique.white};
  text-decoration: inherit;
  @media ${deviceMax.mobileL} {
    border-radius: 0;
    margin: 0 0 ${pxToRem(20)};
    max-width: 100%;
  }
`

export const StyledImage = styled.div`
  justify-content: center;
  display: flex;
  margin-bottom: ${pxToRem(10)};
  align-items: center;
  height: ${pxToRem(160)};

  * {
    object-fit: cover;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
    height: ${pxToRem(160)};
    width: 100%;
  }
`

export const StyledButtons = styled.div`
  display: flex;
  width: 100%;
  flex-basis: auto;
  gap: ${pxToRem(10)};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
`

export const StyledBodyCard = styled.div`
  flex-grow: 1;
`

export const StyledButton = styled(Button)`
  justify-content: center;
  height: ${pxToRem(50)};
  max-width: calc(55% - ${pxToRem(10)});
  flex-shrink: 1;
  flex-grow: 1;
  @media ${deviceMax.mobileL} {
    max-width: 100%;
    width: 100%;
  }
`

export const StyledButtonDownload = styled(ButtonDownload)`
  flex-shrink: 1;
  flex-grow: 1;

  @media ${deviceMax.mobileL} {
    max-width: 100%;
    width: 100%;
  }
`

export const StyleHeading = styled(Heading)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: ${pxToRem(10)};
  text-overflow: ellipsis;
`

export const StyledRichText = styled.div`
  display: -webkit-box;
  overflow: hidden;
  margin-bottom: ${pxToRem(10)};
  max-width: 100%;
  max-height: ${pxToRem(56)};
  text-overflow: ellipsis;
  text-align: ${({$alignment}) => ($alignment ? $alignment : 'left')};
  font-size: ${({theme}) => theme.fonts.sizes.base} !important;
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  line-height: ${({theme}) => theme.fonts.lineHeight.button};
  color: ${({theme}) => theme.colors.opacity.black70};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  p {
    display: ${({
                  $browser,
                  $mobileSystem
                }) => ($browser === BrowserName.Safari || $mobileSystem === MobileSystemName.IOS) ? 'inline' : 'block'};
  }

  ul {
    display: ${({
                  $browser,
                  $mobileSystem
                }) => ($browser === BrowserName.Safari || $mobileSystem === MobileSystemName.IOS) ? 'inline-block' : 'block'};
  }

  figure {
    display: ${({$browser, $mobileSystem}) =>
            $browser === BrowserName.Safari || $mobileSystem === MobileSystemName.IOS
                    ? 'none'
                    : 'block'};
  }

`

export const StyledLabel = styled.span`
  display: inline-block;
  overflow: hidden;
  margin-right: ${pxToRem(10)};
  max-width: calc(100% - ${pxToRem(26)});
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const StyleIcon = styled(ArrowRight)`
  display: inline-block;
  margin-left: ${pxToRem(2)};
  width: ${pxToRem(25)};
  height: ${pxToRem(24)};
  padding: ${pxToRem(3)} ${pxToRem(3)};
  border: ${pxToRem(1)} solid ${({theme}) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`
